import { finalCta } from '@/lib/marketing/content'

type Props = {
  onOpenDemo: () => void
}

export function FinalCTA({ onOpenDemo }: Props) {
  return (
    <section id="demo" className="py-16 sm:py-24">
      <div className="max-w-[960px] mx-auto px-4 sm:px-6">
        <div className="relative">
          {/* Background glow */}
          <div className="absolute inset-0 bg-[#71ED7F]/[0.03] rounded-3xl blur-3xl pointer-events-none" />

          <div className="relative bg-[#001716] rounded-2xl border border-[#71ED7F]/20 p-8 sm:p-12 text-center shadow-[0_8px_32px_-8px_rgba(0,0,0,0.4)]">
            {/* Decorative elements */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2">
              <div className="w-16 h-16 rounded-2xl bg-[#71ED7F]/20 border border-[#71ED7F]/30 flex items-center justify-center">
                <svg className="w-8 h-8 text-[#71ED7F]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                </svg>
              </div>
            </div>

            <div className="pt-6">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-medium font-display text-white mb-4">
                {finalCta.headline}
              </h2>

              <p className="text-white/50 max-w-lg mx-auto mb-8 text-sm sm:text-base">
                {finalCta.subheadline}
              </p>

              {/* CTA Button */}
              <div className="relative inline-block mb-6">
                <div className="absolute inset-0 bg-[#71ED7F]/20 rounded-full blur-xl pointer-events-none" />
                <button
                  onClick={onOpenDemo}
                  className="relative inline-flex items-center justify-center bg-[#71ED7F] text-[#001716] px-10 py-4 rounded-full text-sm font-semibold tracking-wide hover:shadow-[0_0_45px_-5px_rgba(113,237,127,0.6)] transition-all"
                >
                  {finalCta.cta}
                </button>
              </div>

              {/* Reassurance */}
              <p className="text-white/30 text-xs sm:text-sm">
                {finalCta.reassurance}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
